import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EnvironementView from './EnvironementView';

const mapStateToProps = state => ({
  translations: state.i18n.translations[state.i18n.lang],
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const EnvironementContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EnvironementView);

export default EnvironementContainer;
